import React from 'react';
import { Col, Container, Row } from 'reactstrap';

import IngressoDetalhe from './components/IngressoDetalhe';

const Ingresso = (props) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Detalhe do Ingresso</h3>
      </Col>
    </Row>
    <Row>
      <IngressoDetalhe props={props} />
    </Row>
  </Container>
);

export default Ingresso;
